package songwritersnotebook.app

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import org.jetbrains.skiko.wasm.onWasmReady
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.FirebaseOptions
import kotlinx.coroutines.launch
import songwritersnotebook.app.utils.AuthHandler
import songwritersnotebook.app.utils.AuthCredentials
import songwritersnotebook.app.database.DatabaseDriverFactory
import songwritersnotebook.app.di.PlatformDependencyProvider
import songwritersnotebook.app.di.DatabaseModule
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.Alignment
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        // Initialize Firebase for Web (null context required for JS target)
        Firebase.initialize(
            context = null,
            options = FirebaseOptions(
                apiKey = "AIzaSyDSdUkR_-PmMKvrK2dmj-0SXPlrqqrAwfQ",
                applicationId = "1:162603069875:web:376cdf3c72769484639bc6",
                projectId = "songwritersnotebook-app",
                storageBucket = "songwritersnotebook-app.firebasestorage.app",
                authDomain = "songwritersnotebook-app.firebaseapp.com"
            )
        )

        // We no longer initialize AppCheck natively here because app-bridge.js already initializes
        // both the Firebase App and AppCheck. Doing it twice causes ReCaptcha double-render crashes
        // and network timeouts.
        // We use a CustomProvider for the Modular SDK (@firebase/app-check) 
        // to fetch tokens from the Compat SDK (firebase.appCheck) initialized in app-bridge.js.
        // This prevents ReCaptcha double-render crashes while ensuring Firestore requests are authenticated.
        js("""
            try {
                var firestoreMod = require('@firebase/firestore');
                var appMod = require('@firebase/app');
                var appCheckMod = require('@firebase/app-check');
                
                // --- ENABLE FIRESTORE DEBUG LOGGING ---
                firestoreMod.setLogLevel('debug');
                
                if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
                    console.log("Bridge: Skipping GitLive Modular App Check on localhost");
                } else {
                    // Bridge App Check to GitLive Modular SDK instance
                    var app = appMod.getApp(); 
                    appCheckMod.initializeAppCheck(app, {
                      provider: new appCheckMod.CustomProvider({
                        getToken: function() {
                          return new Promise(function(resolve, reject) {
                             if (window.snBridge && window.snBridge.getAppCheckToken) {
                                 window.snBridge.getAppCheckToken().then(function(token) {
                                   resolve({ token: token, expireTimeMillis: Date.now() + 3600000 });
                                 }).catch(function(e) {
                                   reject(e);
                                 });
                             } else {
                                 reject(new Error("snBridge not ready"));
                             }
                          });
                        }
                      }),
                      isTokenAutoRefreshEnabled: true
                    });
                    console.log("Bridge: Successfully connected Modular App Check to Compat SDK!");
                }
            } catch(e) {
                console.error("Bridge: Failed to initialize GitLive App Check overrides:", e);
            }
        """)

        val authHandler = AuthHandler()
        
        // Initialize Database asynchronously
        val driverFactory = DatabaseDriverFactory()
        val platformDependencyProvider = PlatformDependencyProvider()
        val databaseModule = DatabaseModule(driverFactory, platformDependencyProvider)
        PlatformDependencyProvider.databaseModule = databaseModule

        ComposeViewport("compose-application") {
            val scope = rememberCoroutineScope()
            var isInitialized by remember { mutableStateOf(false) }
            
            LaunchedEffect(Unit) {
                try {
                    databaseModule.initialize()
                    println("DEBUG_DIAG: Web Database initialized")
                    isInitialized = true
                } catch (e: Exception) {
                    println("DEBUG_DIAG: Failed to initialize web database: $e")
                }
            }

            if (isInitialized) {
                SongwritersNotebookApp(
                    onGoogleSignIn = {
                        scope.launch {
                            authHandler.firebaseAuthWithGoogle(AuthCredentials())
                        }
                    }
                )
            } else {
                Box(
                    modifier = Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    CircularProgressIndicator()
                }
            }
        }
    }
}
